<template>
  <div>
      <v-dialog
        v-model="loading"
        persistent
        width="600"
        >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            Proccessing
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-layout wrap row justify-start pa-2 py-5>
        <v-flex xs4 px-2>
          <v-card :loading="loading" class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Log
						</v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 pa-1>
                  <v-btn color="primary" @click="()=>{
                      LoadLog()
                      scroll ()
                    }">get latest</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-menu
                    v-model="fsd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator">
                      <v-text-field
                        v-model="fTLDate"
                        label="From Status Date"
                        append-icon="event"
                        readonly
                        hide-details
                        clearable
                        solo
                        :loading="loading"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="fTLDate" @input="fsd = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <!-- <v-flex xs6 pa-1>
                  <v-menu
                    ref="menu"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value="time"
                    transition="scale-transition"
                    offset-y
                    format="24hr"
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template slot="activator">
                      <v-text-field
                        v-model="time"
                        solo
                        label="Picker in menu"
                        prepend-inner-icon="access_time"
                        readonly
                        @click="menu2 = true"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu2"
                      v-model="time"
                      full-width
                      @click:minute="$refs.menu.save(time)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex> -->
                <v-flex xs6 pa-1>
                  <v-menu
                    v-model="tsd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator">
                      <v-text-field
                        v-model="tTLDate"
                        label="To Status Date"
                        append-icon="event"
                        readonly
                        hide-details
                        clearable
                        solo
                        :loading="loading"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="tTLDate" @input="tsd = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <!-- <v-flex xs6 pa-1>
                  <v-menu
                    ref="menu3"
                    v-model="menu4"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value="time"
                    transition="scale-transition"
                    offset-y
                    format="24hr"
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template slot="activator">
                      <v-text-field
                        v-model="time2"
                        solo
                        label="Picker in menu"
                        prepend-inner-icon="access_time"
                        readonly
                        @click="menu4 = true"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="menu4"
                      v-model="time2"
                      full-width
                      @click:minute="$refs.menu3.save(time2)"
                    ></v-time-picker>
                  </v-menu>
                </v-flex> -->
                <v-flex xs6 pa-1>
                  <v-select
                    hide-details
                    :items="warehouses"
                    solo
                    :loading="loading"
                    item-value="name"
                    v-model="selectedWarehouse"
                    label="Warehouse"
                    item-text="name"
                    clearable
                  ></v-select>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="primary" @click="()=>{
                      LoadByFilter()
                    }">get by filter</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                <v-btn color="primary" @click="()=>{
                      ExportByFilter()
                    }">export by filter</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-menu
                    v-model="fsd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator">
                      <v-text-field
                        v-model="fTLDate"
                        label="From Status Date"
                        append-icon="event"
                        readonly
                        hide-details
                        clearable
                        solo
                        :loading="loading"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="fTLDate" @input="fsd = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-menu
                    v-model="tsd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <template slot="activator">
                      <v-text-field
                        v-model="tTLDate"
                        label="To Status Date"
                        append-icon="event"
                        readonly
                        hide-details
                        clearable
                        solo
                        :loading="loading"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="tTLDate" @input="tsd = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-select
                    hide-details
                    :items="warehouses"
                    solo
                    :loading="loading"
                    item-value="name"
                    v-model="selectedWarehouse"
                    label="Warehouse"
                    item-text="name"
                    clearable
                  ></v-select>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-text-field
                    label="SKU"
                    solo
                    :loading="loading"
                    v-model="selectedSKU"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="primary" @click="()=>{
                      LoadBySKU()
                    }">get by SKU & Warehouse</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="primary" @click="()=>{
                      ExportBySKU()
                    }">export by SKU & Warehouse</v-btn>
                </v-flex>
                <v-flex xs12 md12 pa-1>
									<v-textarea
										label="Keys OR Document Numbers"
										v-model="spastedData"
										solo
									></v-textarea>
              	</v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="primary" @click="()=>{
                      searchByKey()
                    }">get by key</v-btn>
                </v-flex>
                <v-flex xs6 pa-1>
                  <v-btn color="primary" @click="()=>{
                      searchByDocumentID()
                    }">get by document ID</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							<v-btn color="primary" @click="exportData()">export</v-btn>

            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs8 px-2>
          <v-card :loading="loading" class="elevation-24 text-md-center">
            <v-card-title class="headline white--text primary">
							Log
              <v-spacer></v-spacer>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="()=>{
                  selectedTransactions = []
                  selectedGroupTransactions = []
                }">clear selections
              </v-btn>
              <v-btn color="secondary" :loading="loading" :disabled="loading" @click="cancelTransaction()">cancel order</v-btn>
              <v-btn color="error" :loading="loading" :disabled="loading" @click="cancelPOTransaction()">cancel PO</v-btn>
              <v-btn color="error" :loading="loading" :disabled="loading" @click="cancelMVTransaction()">cancel MV</v-btn>
						</v-card-title>
            <v-card-text>
              <v-layout row wrap style="height:800px;overflow-y:scroll;background:#efefef;" id="scroller">
                <v-flex xs12 v-for="(l, i) in log" :key="i + 'log'" mb-1 mx-2 mt-1>
                  <v-card class="elevation-2 pa-2" :loading="loading">
                    <v-layout row wrap>
                      <v-flex xs2 class="text-xs-center" v-if="checkCancel(l)">
                        <v-btn class="faddtocart" color="error" small 
                            @click="selectedTransactions.push(l)"
                            :disabled="selectedTransactions.map(x=>x.key).includes(l.key) || l.cancel"
                            >
                            <!-- <v-icon left v-if="!selectedTransactions.map(x=>x.key).includes(l.key)">star_border</v-icon> -->
                            <!-- <v-icon left v-if="selectedTransactions.map(x=>x.key).includes(l.key)">star_rate</v-icon> -->
                            {{l.product_sku}} X {{l.quantity}}
                        </v-btn>
                      </v-flex>
                      <v-flex xs2 v-if="l.transaction_id" class="text-xs-center">
                        <v-btn class="faddtocart" color="error" small 
                            @click="selectGroupTransactions(l.transaction_id)"
                            :disabled="selectedGroupTransactions.map(x=>x.transaction_id).includes(l.transaction_id) || l.cancel"
                            >
                            <!-- <v-icon left v-if="!selectedTransactions.map(x=>x.key).includes(l.key)">star_border</v-icon> -->
                            <!-- <v-icon left v-if="selectedTransactions.map(x=>x.key).includes(l.key)">star_rate</v-icon> -->
                            {{l.transaction_id}}
                        </v-btn>
                      </v-flex>
                      <v-flex xs3 md2 py-2 v-for="(key, k) in Object.keys(l).filter(x=>{
                          let no = ['warehouse_key']
                          if(!no.includes(x)) return x
                        })" :key="k + 'title'">
                        <v-layout row wrap>
                          <v-flex xs12 style="font-size:11px;font-weight:bold;">
                            {{key.toUpperCase()}}
                          </v-flex>
                          <v-flex xs12
                            v-if="l[key]"
                            v-clipboard:copy="l[key]"
                            v-clipboard:success="clipboardSuccessHandler"
                            v-clipboard:error="clipboardErrorHandler"
                          >
                            <v-tooltip top>
                              <span slot="activator">
                                {{l[key].toString() | truncate(12, (typeof l[key] == 'string' && l[key].toString().length>12 ? '..': ''))}}
                              </span>
                              <span>{{ l[key] }}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs1 v-if="l.cancel">
                        <v-card pa-1 color="error">
                          
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
							
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
import { firebase, db, auth, createFirebase, store } from '@/fb';
import { getRandomInt, randomString, getCDate} from '@/customFunction';
import axios from 'axios';
import { productApiUrl, crmApiUrl } from '@/config/urls';
import json2csv from 'json2csv'
const headers = {
  'Accept': 'application/json'
}

export default {
  data(){
    return {
      menu2: false,
      time:null,
      menu4: false,
      time2:null,
			loading: false,
      pastedData:null,
      spastedData:null,
      delimiter:',',
      nKeys:null,
      shippingStatus:[],
      warehouses:[],
      selectedWarehouse:null,
      fsd:null,
      selectedSKU:null,
      fTLDate:null,
      tsd:null,
      tTLDate:null,
      warehouses:[],
      products:[],
      last:null,
      log:[],
      exports:[],
      selectedTransactions:[],
      selectedGroupTransactions:[],
      loading:false,
    }
  },
  methods: {
    checkCancel(l){
      let x = this.log.filter(x=>!x.cancel)[0]
      if(x){
        if(l.transaction_id == x.transaction_id) {
          return true
        }
      }
      return true
    },
    async cancelTransaction() {
      this.loading = true
      this.selectedTransactions = this.selectedGroupTransactions
      let transaction_id = randomString(8, '#Aa')
      let transaction_timestamp = new Date().getTime()
      if(this.selectedTransactions.length) {
        console.log(this.selectedTransactions)
        let orderKeys = {}
        this.selectedTransactions.forEach(x=>{
          if(!orderKeys[x.order_key]) orderKeys[x.order_key] = true
        })
        let statusSetup = await db.ref('shippingstatuses').once('value').then(x=>x.val())
        console.log(statusSetup)
        let statusNames = Object.values(statusSetup).map(x=>x.name)
        console.log(statusNames)
        let keyMap = Object.keys(orderKeys)

        if(keyMap.length && keyMap.length === 1) {
          console.log('keyMap', keyMap)
          console.log('keyMap[0]', keyMap[0])
          let lead = await store.collection('leads').doc(keyMap[0]).get().then(x=>{return {...x.data(), key:keyMap[0]}})
          let o = lead.order.map(x=>{return{sku:x.sku.replace(/\u21b5/g,'').replace('↵', '').trim(), quantity:x.quantity}})
          let compareTrans = {}
          this.selectedTransactions.forEach(x=>{
            if(!compareTrans[x.product_sku]) compareTrans[x.product_sku] = 0
            compareTrans[x.product_sku] += x.quantity
          })
          let compareOrder = {}
          o.forEach(x=>{
            if(!compareOrder[x.sku]) compareOrder[x.sku] = 0
            compareOrder[x.sku] += x.quantity
          })
          let oCompare = Object.keys(compareOrder)
          let unmatch = []
          oCompare.forEach(x=>{
            if(compareOrder[x] && compareTrans[x] && compareOrder[x] == compareTrans[x]) {
            } else {
              unmatch.push(x)
            }
          })
          if(unmatch.length === 0) {
            console.log("ready to reverse")
            let sorted = this.selectedTransactions.sort((a, b)=> b.timestamp - a.timestamp)
            let sortedIndex = this.log.filter(x=>!x.cancel).findIndex(x=>x.timestamp == sorted[sorted.length-1].timestamp) + 1
            let targetT = this.log.filter(x=>!x.cancel)[sortedIndex]
            console.log('------------------------------------');
            console.log(this.log)
            console.log(this.selectedTransactions.length-1)
            console.log(this.selectedTransactions.length)
            console.log(compareTrans);
            console.log(compareOrder);
            console.log(targetT);
            console.log(statusNames);
            console.log(statusNames);
            console.log('------------------------------------');
            let shortSt = targetT ? targetT.status.split(' ').join('_').toLowerCase() :'pending'
            let statusFinder = statusNames.map(x=>x.split(' ').join('_').toLowerCase()).findIndex(x=> x == shortSt)
            let rStatus = statusNames[statusFinder]
            let rLast = targetT ? targetT.transaction : 'none'
            console.log(shortSt, statusFinder, rStatus, rLast)
            console.log('update lead', {
              shipping_status: rStatus,
              last_transaction: rLast
            }, keyMap[0]);

            await store.collection('leads').doc(keyMap[0]).update({
              shipping_status: rStatus,
              last_transaction: rLast
            });
            try {
              let update_lead = await store.collection('leads').doc(keyMap[0]).get().then(x=>{return {...x.data(), key:keyMap[0]}})
              await axios.post(productApiUrl('leads'), update_lead, {headers}).then(x=>x.data)

              if(update_lead.ninja) {
                let pu = await axios.post(crmApiUrl(`crmleads/${update_lead.id}`), update_lead, {headers}).then(x=>x.data).catch(async (error)=> console.log('NINJA ERROR ', error))
              }
            } catch (error) {
              console.log('lead sync error', error)
            }
            let abc = [];
            (async x=>{
              for (let i = 0; i < this.selectedTransactions.length; i++) {
                const trans = this.selectedTransactions[i];
                console.log('update transaction', {
                  key: trans.key,
                  cancel:true
                });
                let a = await store.collection('products').where('sku', '==', trans.product_sku.replace(/\u21b5/g,'').replace('↵', '').trim()).get().then(x=>x.docs[0].data());
                if(trans.transaction == 'add') {
                  var sfDocRef = store.collection("products").doc(a.key);
                  await store.runTransaction(function(transaction) {
                    return transaction.get(sfDocRef).then(function(sfDoc) {
                        if (!sfDoc.exists) {
                            throw "Document does not exist!";
                        }
                        var product = sfDoc.data()
                        product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity = parseInt(product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity) - parseInt(trans.quantity);
                        transaction.update(sfDocRef, product);
                    });
                  })
                  await store.collection('warehouseactions').add({
                    product_sku:trans.product_sku.trim(),
                    product_key:a.key,
                    user:this.$props.userName,
                    date:getCDate(),
                    status:rStatus,
                    transaction_timestamp,
                    transaction_id,
                    timestamp:new Date(getCDate()).getTime(),
                    quantity:parseInt(trans.quantity),
                    transaction:'subtract',
                    warehouse_name:trans.warehouse_name,
                    warehouseh_key:this.warehouses.filter(x=>x.name == trans.warehouse_name)[0].key,
                    order_key:lead.key,
                    document_number: lead.document_number ? lead.document_number : 0
                  })
                } else if(trans.transaction == 'subtract') {
                  var sfDocRef = store.collection("products").doc(a.key);
                  await store.runTransaction(function(transaction) {
                    return transaction.get(sfDocRef).then(function(sfDoc) {
                        if (!sfDoc.exists) {
                            throw "Document does not exist!";
                        }
                        var product = sfDoc.data()
                        product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity = parseInt(product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity) + parseInt(trans.quantity);
                        transaction.update(sfDocRef, product);
                    });
                  })
                  await store.collection('warehouseactions').add({
                    product_sku:trans.product_sku.trim(),
                    product_key:a.key,
                    user:this.$props.userName,
                    date:getCDate(),
                    status:rStatus,
                    transaction_timestamp,
                    transaction_id,
                    timestamp:new Date(getCDate()).getTime(),
                    quantity:parseInt(trans.quantity),
                    transaction:'add',
                    warehouse_name:trans.warehouse_name,
                    warehouseh_key:this.warehouses.filter(x=>x.name == trans.warehouse_name)[0].key,
                    order_key:lead.key,
                    document_number: lead.document_number ? lead.document_number : 0
                  })
                }
                
                trans.cancel = true
                await store.collection('warehouseactions').doc(trans.key).update({cancel:true})
              }
              this.loading = false
              this.searchByKey()
            })()
            let sep = null;
          } else {
            this.$emit('snackbarNotification', `Please select All Transactions of Order`, 'error')
            this.loading = false

          }
        } else {
          this.$emit('snackbarNotification', `Several Orders Selected`, 'error')
          this.loading = false
        }
      } else if (this.selectedGroupTransactions.length) {
        console.log(this.selectedGroupTransactions)
        
      } else {
        this.$emit('snackbarNotification', `No Transactions Selected`, 'error')
        this.loading = false

      }
    },
    async cancelPOTransaction() {
      this.loading = true
      this.selectedTransactions = this.selectedGroupTransactions
      let transaction_id = randomString(8, '#Aa')
      let transaction_timestamp = new Date().getTime()
      if(this.selectedTransactions.length) {
        console.log(this.selectedTransactions)
        let orderKeys = {}
        this.selectedTransactions.forEach(x=>{
          if(!orderKeys[x.order_key]) orderKeys[x.order_key] = true
        })
        let keyMap = Object.keys(orderKeys)
        if(keyMap.length && keyMap.length === 1) {
          let po = await store.collection('purchaseOrders').doc(keyMap[0]).get().then(x=>{return {...x.data(), key:keyMap[0]}})
          if(!po) {
            this.loading = false
            return true
          }
          console.log(po)
          let o = po.rec_items.map(x=>{return{sku:x.sku.replace(/\u21b5/g,'').replace('↵', '').trim(), quantity:x.quantity}})
          let compareTrans = {}
          this.selectedTransactions.forEach(x=>{
            if(!compareTrans[x.product_sku]) compareTrans[x.product_sku] = 0
            compareTrans[x.product_sku] += x.quantity
          })
          let compareOrder = {}
          o.forEach(x=>{
            if(!compareOrder[x.sku]) compareOrder[x.sku] = 0
            compareOrder[x.sku] += x.quantity
          })
          let oCompare = Object.keys(compareOrder)
          let unmatch = []
          oCompare.forEach(x=>{
            if(compareOrder[x] && compareTrans[x] && compareOrder[x] == compareTrans[x]) {
            } else {
              unmatch.push(x)
            }
          })
          if(unmatch.length === 0) {
            console.log("ready to reverse")
            console.log('------------------------------------');
            console.log(this.log)
            console.log(compareTrans);
            console.log(compareOrder);
            console.log('------------------------------------');
            let bb = await db.ref('uKeys').push()
            if(!po.status_timeline) po.status_timeline = {}
            po.status_timeline[bb.key] = {
              status:'Purchase',
              agent:this.$props.userName,
              timestamp:new Date(getCDate()).getTime(),
              date:getCDate()
            }
            await db.ref('uKeys').update({
              [bb.key]:null
            })
            po.status = 'Purchase'
            po.transaction = false
            await store.collection('purchaseOrders').doc(keyMap[0]).update(po);
            (async x=>{
              for (let i = 0; i < this.selectedTransactions.length; i++) {
                const trans = this.selectedTransactions[i];
                console.log('update transaction', {
                  key: trans.key,
                  cancel:true
                });
                let a = await store.collection('products').where('sku', '==', trans.product_sku.replace(/\u21b5/g,'').replace('↵', '').trim()).get().then(x=>x.docs[0].data());
                if(trans.transaction == 'add') {
                  var sfDocRef = store.collection("products").doc(a.key);
                  await store.runTransaction(function(transaction) {
                    return transaction.get(sfDocRef).then(function(sfDoc) {
                        if (!sfDoc.exists) {
                            throw "Document does not exist!";
                        }
                        var product = sfDoc.data()
                        product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity = parseInt(product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity) - parseInt(trans.quantity);
                        transaction.update(sfDocRef, product);
                    });
                  })
                  await store.collection('warehouseactions').add({
                    product_sku: trans.product_sku.trim(),
                    product_key: a.key,
                    user: this.$props.userName,
                    date: getCDate(),
                    status: 'Purchase',
                    transaction_timestamp,
                    transaction_id,
                    timestamp: new Date(getCDate()).getTime(),
                    quantity: parseInt(trans.quantity),
                    transaction: 'subtract',
                    warehouse_name: trans.warehouse_name,
                    warehouseh_key: this.warehouses.filter(x=>x.name == trans.warehouse_name)[0].key,
                    order_key: po.key,
                    document_number: po.document_number ? po.document_number : 0
                  })
                } else if(trans.transaction == 'subtract') {
                  var sfDocRef = store.collection("products").doc(a.key);
                  await store.runTransaction(function(transaction) {
                    return transaction.get(sfDocRef).then(function(sfDoc) {
                        if (!sfDoc.exists) {
                            throw "Document does not exist!";
                        }
                        var product = sfDoc.data()
                        product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity = parseInt(product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity) + parseInt(trans.quantity);
                        transaction.update(sfDocRef, product);
                    });
                  })
                  await store.collection('warehouseactions').add({
                    product_sku: trans.product_sku.trim(),
                    product_key: a.key,
                    user: this.$props.userName,
                    date: getCDate(),
                    status: 'Purchase',
                    transaction_timestamp,
                    transaction_id,
                    timestamp: new Date(getCDate()).getTime(),
                    quantity: parseInt(trans.quantity),
                    transaction: 'add',
                    warehouse_name: trans.warehouse_name,
                    warehouseh_key: this.warehouses.filter(x=>x.name == trans.warehouse_name)[0].key,
                    order_key: po.key,
                    document_number: po.document_number ? po.document_number : 0
                  })
                }
                
                trans.cancel = true
                await store.collection('warehouseactions').doc(trans.key).update({cancel:true})
              }
              this.loading = false
              this.searchByKey()
            })()
            let sep = null;
          } else {
            this.$emit('snackbarNotification', `Please select All Transactions of Order`, 'error')
            this.loading = false

          }
        } else {
          this.$emit('snackbarNotification', `Several Orders Selected`, 'error')
          this.loading = false
        }
      } else if (this.selectedGroupTransactions.length) {
        console.log(this.selectedGroupTransactions)
        
      } else {
        this.$emit('snackbarNotification', `No Transactions Selected`, 'error')
        this.loading = false

      }
    },
    async cancelMVTransaction() {
      this.loading = true
      this.selectedTransactions = this.selectedGroupTransactions
      let transaction_id = randomString(8, '#Aa')
      let transaction_timestamp = new Date().getTime()
      if(this.selectedTransactions.length) {
        console.log(this.selectedTransactions)
        let orderKeys = {}
        this.selectedTransactions.forEach(x=>{
          if(!orderKeys[x.order_key]) orderKeys[x.order_key] = true
        })
        let keyMap = Object.keys(orderKeys)
        if(keyMap.length && keyMap.length === 1) {
          let po = await store.collection('moveorders').doc(keyMap[0]).get().then(x=>{return {...x.data(), key:keyMap[0]}})
          if(!po) {
            this.loading = false
            return true
          }
          console.log(po)
          let o = po.items.map(x=>{return{sku:x.sku.replace(/\u21b5/g,'').replace('↵', '').trim(), quantity:x.quantity}})
          
          if(o) {
            console.log("ready to reverse")
            console.log('------------------------------------');
            console.log(this.log)
            console.log('------------------------------------');
            await store.collection('moveorders').doc(keyMap[0]).update({
              status: 'cancel',
              cancel:true
            });
            (async x=>{
              for (let i = 0; i < this.selectedTransactions.length; i++) {
                const trans = this.selectedTransactions[i];
                console.log('update transaction', {
                  key: trans.key,
                  cancel:true
                });
                let a = await store.collection('products').where('sku', '==', trans.product_sku.replace(/\u21b5/g,'').replace('↵', '').trim()).get().then(x=>x.docs[0].data());
                if(trans.transaction == 'add') {
                  var sfDocRef = store.collection("products").doc(a.key);
                  await store.runTransaction(function(transaction) {
                    return transaction.get(sfDocRef).then(function(sfDoc) {
                        if (!sfDoc.exists) {
                            throw "Document does not exist!";
                        }
                        var product = sfDoc.data()
                        product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity = parseInt(product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity) - parseInt(trans.quantity);
                        transaction.update(sfDocRef, product);
                    });
                  })
                  await store.collection('warehouseactions').add({
                    product_sku: trans.product_sku.trim(),
                    product_key: a.key,
                    user: this.$props.userName,
                    date: getCDate(),
                    status: 'cancel',
                    transaction_timestamp,
                    transaction_id,
                    timestamp: new Date(getCDate()).getTime(),
                    quantity: parseInt(trans.quantity),
                    transaction: 'subtract',
                    warehouse_name: trans.warehouse_name,
                    warehouseh_key: this.warehouses.filter(x=>x.name == trans.warehouse_name)[0].key,
                    order_key: po.key,
                    document_number: po.document_number ? po.document_number : 0
                  })
                  await store.collection('moveorders').doc(po.key).update({in:false})
                } else if(trans.transaction == 'subtract' && !po.in) {
                  var sfDocRef = store.collection("products").doc(a.key);
                  await store.runTransaction(function(transaction) {
                    return transaction.get(sfDocRef).then(function(sfDoc) {
                        if (!sfDoc.exists) {
                            throw "Document does not exist!";
                        }
                        var product = sfDoc.data()
                        product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity = parseInt(product.warehouses.filter(x=>x.warehouse == trans.warehouse_name)[0].quantity) + parseInt(trans.quantity);
                        transaction.update(sfDocRef, product);
                    });
                  })
                  await store.collection('warehouseactions').add({
                    product_sku: trans.product_sku.trim(),
                    product_key: a.key,
                    user: this.$props.userName,
                    date: getCDate(),
                    status: 'cancel',
                    transaction_timestamp,
                    transaction_id,
                    timestamp: new Date(getCDate()).getTime(),
                    quantity: parseInt(trans.quantity),
                    transaction: 'add',
                    warehouse_name: trans.warehouse_name,
                    warehouseh_key: this.warehouses.filter(x=>x.name == trans.warehouse_name)[0].key,
                    order_key: po.key,
                    document_number: po.document_number ? po.document_number : 0
                  })
                  await store.collection('moveorders').doc(po.key).update({out:false})
                }
                trans.cancel = true
                await store.collection('warehouseactions').doc(trans.key).update({cancel:true})
              }
              this.loading = false
              this.searchByKey()
            })()
            let sep = null;
          } else {
            this.$emit('snackbarNotification', `Please select All Transactions of Order`, 'error')
            this.loading = false

          }
        } else {
          this.$emit('snackbarNotification', `Several Orders Selected`, 'error')
          this.loading = false
        }
      } else if (this.selectedGroupTransactions.length) {
        console.log(this.selectedGroupTransactions)
        
      } else {
        this.$emit('snackbarNotification', `No Transactions Selected`, 'error')
        this.loading = false

      }
    },
    async selectGroupTransactions(transaction_id){
      this.selectedGroupTransactions.push(...this.log.filter(x=>x.transaction_id == transaction_id))
    },
    async getShippingStatuses(){
      let a = await db.ref('shippingstatuses').once('value').then(x=>x.val())
      this.shippingStatus = Object.values(a).map(x=>x.name)
    },
    async getWarehouses(){
      this.loading = true
      this.warehouses = await store.collection('warehouses').get().then(x=>x.docs.map(y=>{
        return {
          ...y.data(),
          key:y.id
        }
      }).filter(x=>!x.lock))
      
      this.loading = false
    },
    async getProducts(){
      this.loading = true
      this.products = await store.collection('products').get()
      .then(x=>x.docs.map(y=>{
        return {
          ...y.data(),
          warehouses:y.data().warehouses? y.data().warehouses:[]
        }
      }))
      this.loading = false
    },
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
		guessDelimiters (text, possibleDelimiters) {
			return possibleDelimiters.filter(weedOut);
			function weedOut (delimiter) {
				var cache = -1;
				return text.split('\n').every(checkLength);
				function checkLength (line) {
					if (!line) {
							return true;
					}
					var length = line.split(delimiter).length;
					if (cache < 0) {
							cache = length;
					}
					return cache === length && length > 1;
				}
			}
		},
		getArray(){
			let csv = this.pastedData
			let dels = [' ', '  ', ',', '	', '\t']
			this.delimiter = ','
			if(this.delimiter && this.delimiter > 1) {
				this.$emit('snackbarNotification', `Please export as CSV`, 'error')
				return
			}
			var lines=csv.split("\n");
      var result = [];
			var headers=lines[0].split(this.delimiter);
			for(var i=1;i<lines.length;i++){
					if (!lines[i])
							continue
					var obj = {};
					var currentline=lines[i].split(this.delimiter);
					for(var j=0;j<headers.length;j++){
							obj[headers[j]] = currentline[j];
					}
					result.push(obj);
			}
			console.log(result);
			return result
    },
    async searchByKey(){
      this.selectedTransactions = []
      this.selectedGroupTransactions = []
      this.exports = []
      this.log = []
			let a = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>x.trim());
      (async x=>{
        for (let i = 0; i < a.length; i++) {
          const r = a[i];
          let l = await store.collection('warehouseactions').where('order_key', '==', r).get().then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
          if(l){
            this.log.push(...l.sort((a, b)=> b.timestamp - a.timestamp))
            this.exports.push(...l)
          } else {
            this.nKeys.push(r.key)
          }
        }
      })()
    },
    async searchByDocumentID() {
      this.selectedTransactions = []
      this.selectedGroupTransactions = []
      this.exports = []
      this.log = []
			let a = this.spastedData.split('\n').filter(x=> x && x.trim() != '').map(x=>x.trim());
      (async x=>{
        for (let i = 0; i < a.length; i++) {
          const r = a[i];
          let l = await store.collection('warehouseactions').where('document_number', '==', r).get().then(x=>x.docs.map(y=>{return {...y.data(), key:y.id}}));
          if(l){
            this.log.push(...l.sort((a, b)=> b.timestamp - a.timestamp))
            this.exports.push(...l)
          } else {
            this.nKeys.push(r.key)
          }
        }
      })()
    },
    convertToCSV(arr) {
      const array = [Object.keys(arr[0])].concat(arr)
          return array.map(it => {
            return Object.values(it).toString()
          }).join('\n')
    },
    pivot(arr) {
        var mp = new Map();
        
        function setValue(a, path, val) {
            if (Object(val) !== val) { // primitive value
                var pathStr = path.join('.');
                var i = (mp.has(pathStr) ? mp : mp.set(pathStr, mp.size)).get(pathStr);
                a[i] = val;
            } else {
                for (var key in val) {
                    setValue(a, key == '0' ? path : path.concat(key), val[key]);
                }
            }
            return a;
        }
        
        var result = arr.map( obj => setValue([], [], obj) );
        return [[...mp.keys()], ...result];
    },
    toCsv(arr) {
        return arr.map( row => 
            row.map ( val => isNaN(val) ? JSON.stringify(val) : +val ).join(',')
        ).join('\n');
    },
    exportData(data = this.exports, name){
      let a = json2csv.parse(data)
      console.log(a)
      let csvContent = "data:text/csv;charset=utf-8," 
      var encodedUri =  csvContent + encodeURIComponent(a);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      let n = name ? name : 'log_export'
      link.setAttribute("download", `${n}.csv`);
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    async onlyMe(){
      console.log('started')
      
    },
    async LoadLog(){
      this.selectedTransactions = []
      this.selectedGroupTransactions = []
      this.loading = true
      let timestamp = this.date ? new Date(this.date).getTime() :  new Date().getTime()
      let a = await store.collection(`warehouseactions`).orderBy("timestamp", "desc").limit(10).get().then(x=>x.docs.map((y, i)=>{
        if(i==x.docs.length-1) this.last = y
        return {...y.data(), key:y.id}
      }))
      // let a = await store.collection(`warehouseactions`).orderBy("date", "desc").limit(10).get().then(x=>x.docs.map((y, i)=>{
      //   if(i==x.docs.length-1) this.last = y
      //   return y.data()
      // }))
      this.log = a
      this.exports = this.log
      this.loading = false
    },
    async nextLog(){
      this.selectedTransactions = []
      this.selectedGroupTransactions = []
      this.loading = true
      let timestamp = this.date ? new Date(this.date).getTime() :  new Date().getTime()
      let a = await store.collection(`warehouseactions`).where("timestamp", "<", timestamp).orderBy("timestamp", "desc").limit(10).startAfter(this.last).get().then(x=>x.docs.map((y, i)=>{
        if(i==x.docs.length-1) this.last = y
        return {...y.data(), key:y.id}
      }))
      // let a = await store.collection(`warehouseactions`).orderBy("date", "desc").limit(10).startAfter(this.last).get().then(x=>x.docs.map((y, i)=>{
      //   if(i==x.docs.length-1) this.last = y
      //   return y.data()
      // }))
      this.log = [...this.log, ...a]
      this.exports = this.log
      this.loading = false
    },
    async LoadByFilter(){
      this.selectedTransactions = []
      this.selectedGroupTransactions = []
      this.loading = true
      let timestampf = this.fTLDate ? new Date(this.fTLDate).getTime() :  new Date().getTime()
      let timestampt = this.tTLDate ? new Date(this.tTLDate).getTime() :  new Date().getTime() - 24*60*60*1000
      console.log(this.selectedWarehouse)

      let a = null
      if(this.selectedWarehouse) {
        a = await store.collection(`warehouseactions`)
          .where("timestamp", ">=", timestampf)
          .where("timestamp", "<=", timestampt)
          .where("warehouse_name", "==", this.selectedWarehouse)
          .get().then(x => x.docs.map((y, i) => {
            if (i == x.docs.length - 1) this.last = y
            return { ...y.data(), key: y.id }
          }))
      } else {
        a = await store.collection(`warehouseactions`)
          .where("timestamp", ">=", timestampf)
          .where("timestamp", "<=", timestampt)
          .get().then(x => x.docs.map((y, i) => {
            if (i == x.docs.length - 1) this.last = y
            return { ...y.data(), key: y.id }
          }))
      }
      console.log(a)
      this.log = a.sort((a,b)=>b.timestamp - a.timestamp)
      this.exports = [...this.log]
      this.loading = false
    },
    async LoadBySKU(){
      this.selectedTransactions = []
      this.selectedGroupTransactions = []
      this.loading = true
      console.log(this.selectedSKU)
      let timestampf = this.fTLDate ? new Date(this.fTLDate).getTime() :  new Date().getTime()
      let timestampt = this.tTLDate ? new Date(this.tTLDate).getTime() :  new Date().getTime() - 24*60*60*1000
      let a = null
      if(this.selectedWarehouse) {
        a = await store.collection(`warehouseactions`)
          .where("timestamp", "<=", timestampt)
          .where("timestamp", ">=", timestampf)
          .where("warehouse_name", "==", this.selectedWarehouse)
          .where("product_sku", "==", this.selectedSKU).get().then(x => x.docs.map((y, i) => {
            if (i == x.docs.length - 1) this.last = y
            return { ...y.data(), key: y.id }
          }))
      } else {
        a = await store.collection(`warehouseactions`)
          .where("timestamp", "<=", timestampt)
          .where("timestamp", ">=", timestampf)
          .where("product_sku", "==", this.selectedSKU).get().then(x => x.docs.map((y, i) => {
            if (i == x.docs.length - 1) this.last = y
            return { ...y.data(), key: y.id }
          }))
      }
      console.log(a)
      this.log = a.sort((a,b)=>b.timestamp - a.timestamp)
      // .filter(x=>{
      //   if(this.selectedWarehouse ) {
      //     if(x.warehouse_name == this.selectedWarehouse) {
      //       return x
      //     }
      //   } else {
      //     return x
      //   }
      // })
      this.exports = [...this.log]
      this.loading = false
    },
    async ExportBySKU(){
      this.selectedTransactions = []
      this.selectedGroupTransactions = []
      this.loading = true
      console.log(this.selectedSKU)
      let timestampf = this.fTLDate ? new Date(this.fTLDate).getTime() :  new Date().getTime()
      let timestampt = this.tTLDate ? new Date(this.tTLDate).getTime() :  new Date().getTime() - 24*60*60*1000
      let a = null
      if(this.selectedWarehouse) {
        a = await store.collection(`warehouseactions`)
          .where("timestamp", "<=", timestampt)
          .where("timestamp", ">=", timestampf)
          .where("warehouse_name", "==", this.selectedWarehouse)
          .where("product_sku", "==", this.selectedSKU).get().then(x => x.docs.map((y, i) => {
            if (i == x.docs.length - 1) this.last = y
            return { ...y.data(), key: y.id }
          }))
      } else {
        a = await store.collection(`warehouseactions`)
          .where("timestamp", "<=", timestampt)
          .where("timestamp", ">=", timestampf)
          .where("product_sku", "==", this.selectedSKU).get().then(x => x.docs.map((y, i) => {
            if (i == x.docs.length - 1) this.last = y
            return { ...y.data(), key: y.id }
          }))
      }
      
      
      console.log(a)
      // .filter(x=>{
      //   if(this.selectedWarehouse ) {
      //     if(x.warehouse_name == this.selectedWarehouse) {
      //       return x
      //     }
      //   } else {
      //     return x
      //   }
      // })
      this.exportData(a.sort((a,b)=>b.timestamp - a.timestamp))
      this.loading = false
    },
    async ExportByFilter(){
      this.selectedTransactions = []
      this.selectedGroupTransactions = []
      this.loading = true
      let timestampf = this.fTLDate ? new Date(this.fTLDate).getTime() :  new Date().getTime()
      let timestampt = this.tTLDate ? new Date(this.tTLDate).getTime() :  new Date().getTime() - 24*60*60*1000
      console.log(this.selectedWarehouse)

      let a = null
      if(this.selectedWarehouse) {
        a = await store.collection(`warehouseactions`)
          .where("timestamp", ">=", timestampf)
          .where("timestamp", "<=", timestampt)
          .where("warehouse_name", "==", this.selectedWarehouse)
          .get().then(x => x.docs.map((y, i) => {
            if (i == x.docs.length - 1) this.last = y
            return { ...y.data(), key: y.id }
          }))
      } else {
        a = await store.collection(`warehouseactions`)
          .where("timestamp", ">=", timestampf)
          .where("timestamp", "<=", timestampt)
          .get().then(x => x.docs.map((y, i) => {
            if (i == x.docs.length - 1) this.last = y
            return { ...y.data(), key: y.id }
          }))
      }
      
      console.log(a)
      // .filter(x=>{
      //   if(this.selectedWarehouse ) {
      //     if(x.warehouse_name == this.selectedWarehouse) {
      //       return x
      //     }
      //   } else {
      //     return x
      //   }
      // })
      this.exportData(a.sort((a,b)=>b.timestamp - a.timestamp))
      this.loading = false
    },
    scroll () {
      let a = document.getElementById('scroller')
      a.onscroll = () => {
        if (a.scrollHeight - a.scrollTop === a.clientHeight
          && this.loading == false
          ) {
          this.nextLog()
        }
      };
    },
  },
  props:{
		superAdmin:{
			required:true
		},
		userName:{
			default:null
		},
		beta:{
			default:null
		}
  },
  computed:{
    
  },
  async created(){
    
    this.getShippingStatuses()
    // this.getProducts()
    this.getWarehouses()
    








  },
  mounted (){
  }
}
</script>

<style>
.tokenField * {
  color:white !important;
}
</style>
